module.exports = __webpack_public_path__ + "static/study-mobile-app-plp-1e3cdff0f26f0fb0f14671f51c4d3106.png";